import * as React from 'react'
import GibiLogo from '../../../assets/gibiLogo.svg'
import { checkImage } from '../../../helpers/petHelper.tsx'
import authStore from '../../../store/authStore.ts'
import controlStore from '../../../store/controlStore.ts'
import dataStore from '../../../store/dataStore.ts'
import drawerStore from '../../../store/drawerStore.ts'
import mapStore from '../../../store/mapStore.ts'
import safeZoneStore from '../../../store/safeZoneStore.ts'
import { WebSocketIndicator } from '../../../webSockets/WebSocketIndicator.tsx'
import { CenterMapButton } from '../../common/buttons/CenterMapButton.tsx'
import { Dashboard2 } from '../../dashboard2/Dashboard2.tsx'
import { DesktopPetDrawerButton } from '../../petDrawer/DesktopPetDrawerButton.tsx'
import { MiniPetList } from '../../petDrawer/MiniPetList.tsx'
import { PetDrawer } from '../../petDrawer/PetDrawer.tsx'
import { NewSafeZone } from '../../safeZones/NewSafeZone.tsx'
import { SafeZones } from '../../safeZones/SafeZones.tsx'
import { GoogleMapWrapper, POI_OFF } from '../components/GoogleMap/GoogleMapWrapper.tsx'
import { updatedStyles } from '../components/GoogleMap/mapStyles.ts'
import { Directions } from '../Directions/Directions.tsx'
import { MobileDirections } from '../Directions/MobileDirections.tsx'
import { LastKnownLocations } from '../LastKnownLocations/LastKnownLocations.tsx'

import '../map.css'

import { centerMapOnPets } from '../mapHelpers.tsx'
import { TrackMyLocation } from '../TrackMyLocation/TrackMyLocation.tsx'
import { DEFAULT_ZOOM, HAWAII, LatLng } from '../types.ts'
import { ClearDirectionsButton } from '../Directions/ClearDirectionsButton.tsx'

export const MainMap: React.FC = () => {
    const devices = dataStore((s) => s.devices)
    const google = mapStore((s) => s.google)
    const map = mapStore((s) => s.map)
    const isMobile = controlStore(s => s.isOnMobileDevice)
    const pets = dataStore(s => s.pets)
    
    const mapStyle = mapStore(s => s.mapStyle)
    
    React.useEffect(() => {
        mapStore.getState().setMapContext('map')
        controlStore.getState().setCurrentPage('map')
        drawerStore.getState().setDrawerOpen(false)
        isMobile ? drawerStore.getState().setChildren(<MiniPetList/>) : drawerStore.getState().setChildren(
            null)
        if (pets) {
            void Promise.all(pets.map(p => checkImage(p.imageURL))).then(() => {
            })
        }
        controlStore.getState().setCurrentPage('map')
        return () => {
            drawerStore.getState().setDrawerOpen(false)
            isMobile ? drawerStore.getState().setChildren(<MiniPetList/>) : drawerStore.getState().setChildren(
                null)
            safeZoneStore.getState().setActive(false)
        }
    }, [])
    
    // React.useEffect(() => {
    //
    // }, [])
    
    React.useEffect(() => {
        if (map) {
            // @ts-ignore
            const styles = updatedStyles[mapStyle] ? [...(updatedStyles[mapStyle] as []), POI_OFF] : updatedStyles.default
            map.setOptions({styles})
        }
    }, [map])
    
    React.useEffect(() => {
        if (map) {
            // const zoom = map.getZoom()
            // const center = map.getCenter()
            // const styles = styleMap[mapStyle] ? [...(styleMap[mapStyle] as []), POI_OFF] : [POI_OFF]
            // @ts-ignore
            const styles = updatedStyles[mapStyle] ? [...(updatedStyles[mapStyle] as []), POI_OFF] : updatedStyles.default
            map.setOptions({styles})
            const idleListener = map.addListener('idle', () => {
                setTimeout(() => {
                    centerMapOnPets()
                })
                window.google.maps.event.removeListener(idleListener)
            })
            
            // const bounds = mapStore.getState().bounds
            // if (bounds) {
            //     map.fitBounds(bounds)
            //     map.setZoom(zoom)
            // }
        }
    }, [mapStyle])
    
    if (google && map) {
        const bounds = new google.maps.LatLngBounds()
        devices?.forEach(d => bounds.extend({
            lat: d.lastLocation?.properties?.latitude || HAWAII.lat,
            lng: d.lastLocation?.properties?.longitude || HAWAII.lng
        }))
        // map.fitBounds(bounds)
        // console.log('Map - map.fitBounds()')
        setTimeout(() => {
            map.setZoom(mapStore.getState()?.zoom || DEFAULT_ZOOM)
        })
    }
    
    const center = mapStore.getState().map ? mapStore.getState().map?.getCenter() : HAWAII
    
    const height = isMobile ? 'calc(90vh - 64px)' : 'calc(100vh - 56px)'
    
    const mobileHeader = (
        <div id={'mobile-header'}
             className={'w-full h-[64px] bg-white text-primary flex items-center justify-between px-2'}>
            <div><img src={GibiLogo} className={'h-[60px]'}/></div>
            <div className={'text-2xl font-bold'}> Welcome {authStore.getState().firstName} </div>
        </div>
    )
    
    return (
        <div id={'main-map'}
             className={'mainMap relative overflow-hidden border-transparent focus-visible:border-transparent focus-visible:ring-0'}>
            {isMobile ? mobileHeader : null}
            <GoogleMapWrapper height={height} center={center as LatLng} zoom={DEFAULT_ZOOM}>
                <TrackMyLocation/>
                <LastKnownLocations/>
                <SafeZones/>
                <NewSafeZone/>
                {isMobile ? <MobileDirections/> : <Directions/>}

                <div className={'absolute top-2 left-[50%]'}>
                    <ClearDirectionsButton/>
                </div>

                <div className={'absolute bottom-8 left-4'}>
                    <WebSocketIndicator/>
                </div>
                <div className={`absolute ${!isMobile ? 'top-5 right-5' : 'top-20 right-3'}`}>
                    <div className={`flex flex-col justify-start items-center ${!isMobile ? 'gap-4' : 'gap-6'}`}>
                        {!isMobile ? <DesktopPetDrawerButton/> : null}
                        {/*<SafeZoneButton/>*/}
                        {/*<MapSettingsButton/>*/}
                        {/*<HelpButton/>*/}
                    </div>
                </div>
                <div className={`absolute ${!isMobile ? 'bottom-[8rem] right-4' : 'bottom-[2rem] right-5'}`}>
                    <CenterMapButton/>
                </div>
                {!isMobile ? <div id="directions-panel"
                                  className={'absolute top-[30px] left-[25vw] w-[50vw] z-40 bg-primary-content'}/> : null}

                {!isMobile ? (
                    <div id={'dash-2'} className={'absolute top-[10%] select-none'}>
                        <Dashboard2/>
                    </div>
                ) : (
                    <div className={'absolute bottom-0 z-10'}>
                        <PetDrawer/>
                    </div>
                )}

            </GoogleMapWrapper>
        </div>
    )
}
